import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { getPathWithParams } from '../../../helpers/router';
import { businessRoutes } from '../../../utils/routes';
import graf3 from '../../assets/trial/graf-3.svg';
import Animate from '../Animate';

const Trial = ({ t, language }) => (
	<Fragment>
		<div id="trial" className="landing-container-trial">
			<div className="landing-layout">
				<div className="landing-page-trial">
					<div className="landing-page-trial-content">
						<Animate>
							<h2 className="landing-section-title">
								{t("landing.trial.title")}
							</h2>
						</Animate>
						<p className="landing-section-text">
							{t("landing.trial.subtitle")}
						</p>
						<Link
							className="landing-animated landing-button-red"
							to={getPathWithParams({
								path: businessRoutes.register,
								params: { language },
								app: 'business',
							})}
						>
							{t("landing.trial.button")}
						</Link>
					</div>
					<div className="landing-page-trial-image">
						<img
							className="landing-page-trial-image"
							src={graf3}
							alt=""
						/>
					</div>
				</div>
			</div>
		</div>
	</Fragment>
);

export default Trial;
